import React from "react";
import ReactDOM from "react-dom/client";
import axios from "axios";
import "@/index.css";
import "@/i18n";
import App from "@/App";

// Configure axios to send cookies with all requests
axios.defaults.withCredentials = true;

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
